import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Outstream } from '../../index';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "outstream"
    }}>{`Outstream`}</h1>
    <p>{`Outstream video ads automatically play on mute when viewable on screen and pause when out of view. Customizable with
frequency capping and close button delay. The video can remain on-screen to be replayed or closed when the video ends.`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'<Outstream zoneId=\"4176664\" maxWidth={400} />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Outstream,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Outstream zoneId="4176664" maxWidth={400} mdxType="Outstream" />
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Outstream} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      